import axios, { AxiosResponse } from 'axios';
import authHeader from '@/services/auth-header';
import Page from '@/dto/taxation/Page';
import SubscriptionPlanDTO, { PlanComponentPriceDTO } from '@/dto/subscription/SubscriptionPlanDTO';
import { SUBSCRIPTIONS_PLANS_ENDPOINT, SUBSCRIPTIONS_AGREEMENTS_ENDPOINT, SUBSCRIPTIONS_PRICING_PROFILES_ENDPOINT } from '@/constants/endpoints';
import PlanPricePayloadDTO from '@/dto/subscription/PlanPricePayloadDTO';
import AgreementBriefDTO from '@/dto/subscription/AgreementBriefDTO';
import PricingProfileDTO from '@/dto/subscription/PricingProfileDTO';
import CreateAgreementPayloadDTO from '@/dto/subscription/CreateAgreementPayloadDTO';
import CreatePlanPayloadDTO from '@/dto/subscription/CreatePlanPayloadDTO';

export default new class SubscriptionPlanService {
  public getPlans(pageNumber: number, pageSize: number): Promise<AxiosResponse<Page<SubscriptionPlanDTO>>> {
    const params: Record<string, any> = { pageNumber, pageSize };
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
    });
    return axios.get<Page<SubscriptionPlanDTO>>(`${SUBSCRIPTIONS_PLANS_ENDPOINT}?${query.toString()}`, { headers: authHeader() });
  }

  public getPlan(id: number | string): Promise<AxiosResponse<SubscriptionPlanDTO>> {
    return axios.get<SubscriptionPlanDTO>(`${SUBSCRIPTIONS_PLANS_ENDPOINT}/${id}`, { headers: authHeader() });
  }

  public createPlan(payload: import('@/dto/subscription/CreatePlanPayloadDTO').default) {
    return axios.post(`${SUBSCRIPTIONS_PLANS_ENDPOINT}`, { ...payload, isPublic: true, archivePreviousActive: true }, { headers: authHeader() });
  }

  public addPrice(planId: number, component: string, payload: PlanPricePayloadDTO): Promise<AxiosResponse<PlanComponentPriceDTO>> {
    return axios.post<PlanComponentPriceDTO>(
      `${SUBSCRIPTIONS_PLANS_ENDPOINT}/${planId}/components/${component}/prices`,
      payload,
      { headers: authHeader() }
    );
  }

  public getAgreements(planId: number | string, pageNumber: number, pageSize: number): Promise<AxiosResponse<Page<AgreementBriefDTO>>> {
    const params: Record<string, any> = { planId, pageNumber, pageSize };
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
    });
    return axios.get<Page<AgreementBriefDTO>>(`${SUBSCRIPTIONS_AGREEMENTS_ENDPOINT}?${query.toString()}`, { headers: authHeader() });
  }

  public getPricingProfiles(): Promise<AxiosResponse<Array<PricingProfileDTO>>> {
    return axios.get<Array<PricingProfileDTO>>(`${SUBSCRIPTIONS_PRICING_PROFILES_ENDPOINT}`, { headers: authHeader() });
  }

  public createAgreement(payload: CreateAgreementPayloadDTO): Promise<AxiosResponse<AgreementBriefDTO>> {
    return axios.post<AgreementBriefDTO>(`${SUBSCRIPTIONS_AGREEMENTS_ENDPOINT}`, payload, { headers: authHeader() });
  }
}